import { Subcategory } from './subcategory';

export class Member {

    public id: string = "0";
    public uid: string;

    public category: string;

    public subCategory: Subcategory;
        
    public situation: string;
    public balance: number = 0;
    public credit: number = 0;

    public annuity_from: number = 0;

    public name: string;
    public shortName: string;
    public image: string;
    public text: string;
    public address: string;
    public number: string;
    public complement: string;
    public district: string;
    public postalCode: string;
    public city: string;
    public state: string;
    public country: string;
    public foreignCustomer: boolean;
    public email: string;
    public email2: string;
    public cellPhone: string;
    public cellPhonePrefix: string = "";
    public faxPhone: string;
    public clinicPhone: string;
    public hospitalPhone: string;
    public aux1Phone: string;
    public aux2Phone: string;
    public rg: string;
    public cpf: string;
    public crm: string;
    public rqe: string = "";
    public crmUF: string;
    public dateBirth: Date;
    public dateFiliation: Date;
    public dateTitle: Date;
    public regional: string;
    public sex: string;
    
    public obs: string;
    public note: string = ''

    public title: string;
    public staff: boolean;
    public deleted:boolean;

    public created: Date;

    public invite_sent: boolean;
    public selected:boolean;

    public push: boolean = false;

    public zztoken: string = ""
    public zzversion: string = ""

    public tester: boolean;

    public resident_institute: string = "";
    public resident_begin: Date;
    public resident_end: Date;

    public proofOfVaccine: boolean = false;

    public updateBy: string = '';
    public gn1: boolean;
    public linkCurriculum: string = '';

    public sitePolicySigned: any | null;
    
    constructor() {}

}